exports.default = "WebpackMultiOutput-/home/runner/work/web/web/static/js/json/nls/universities.js-WebpackMultiOutput";